export default __webpack_public_path__ + "static/media/unzipped-files.ab54e00f.webp";